import React, { useMemo } from 'react';
import { getPlansByCategory, getPlanByName, Plan } from '../data/planData';
import { SmartAskAmountsInfo } from './SmartAskAmountsInfo';
interface PlanSelectorProps {
  selectedPlan: string | null;
  onSelectPlan: (planName: string) => void;
  includeEvents: boolean;
  includeVM: boolean;
  includeGO: boolean;
  onToggleEvents: () => void;
  onToggleVM: () => void;
  onToggleGO: () => void;
}
export function PlanSelector({
  selectedPlan,
  onSelectPlan,
  includeEvents,
  includeVM,
  includeGO,
  onToggleEvents,
  onToggleVM,
  onToggleGO
}: PlanSelectorProps) {
  const enterprisePlans = getPlansByCategory('Enterprise');
  // Check if selected plan includes Smart Ask Amounts
  const hasSmartAskAmounts = useMemo(() => {
    if (!selectedPlan) return false;
    const plan = getPlanByName(selectedPlan);
    if (!plan) return false;
    return plan.productFeatures.some(pf => pf.features.includes('Smart Ask Amounts'));
  }, [selectedPlan]);
  const renderPlanCard = (plan: Plan) => {
    const isSelected = selectedPlan === plan.name;
    return <button key={plan.name} onClick={() => onSelectPlan(plan.name)} className={`w-full text-left p-4 rounded-lg border-2 transition-all ${isSelected ? 'border-[#0047AB] bg-[#EFF6FF]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-267">
        <h4 className="text-base font-semibold text-gray-900 mb-1" data-id="element-268">
          {plan.name}
        </h4>
        <p className="text-sm text-gray-600" data-id="element-269">{plan.description}</p>
      </button>;
  };
  return <div className="space-y-6" data-id="element-270">
      {/* Enterprise Plans */}
      <div data-id="element-271">
        <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-272">Plans</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-273">
          {enterprisePlans.map(renderPlanCard)}
        </div>
      </div>

      {/* Add-ons Section */}
      {selectedPlan && <div className="pt-4 border-t border-gray-200" data-id="element-274">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-275">
            Add-ons (Optional)
          </h3>
          <p className="text-sm text-gray-600 mb-3" data-id="element-276">
            Events, Volunteer Management, and Gift Officer are available as
            add-ons to any plan
          </p>
          <div className="space-y-2" data-id="element-277">
            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-278">
              <input type="checkbox" checked={includeEvents} onChange={onToggleEvents} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-279" />
              <div data-id="element-280">
                <span className="text-sm font-medium text-gray-900" data-id="element-281">
                  Events
                </span>
                <p className="text-xs text-gray-600" data-id="element-282">
                  Event management and registration
                </p>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-283">
              <input type="checkbox" checked={includeVM} onChange={onToggleVM} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-284" />
              <div data-id="element-285">
                <span className="text-sm font-medium text-gray-900" data-id="element-286">
                  Volunteer Management (VM)
                </span>
                <p className="text-xs text-gray-600" data-id="element-287">
                  Volunteer tracking and coordination
                </p>
              </div>
            </label>

            <label className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 cursor-pointer" data-id="element-288">
              <input type="checkbox" checked={includeGO} onChange={onToggleGO} className="w-4 h-4 text-[#0047AB] border-gray-300 rounded focus:ring-[#0047AB]" data-id="element-289" />
              <div data-id="element-290">
                <span className="text-sm font-medium text-gray-900" data-id="element-291">
                  Gift Officer (GO)
                </span>
                <p className="text-xs text-gray-600" data-id="element-292">
                  Portfolio management and tracking
                </p>
              </div>
            </label>
          </div>
        </div>}

      {/* Smart Ask Amounts Info */}
      {hasSmartAskAmounts && <SmartAskAmountsInfo data-id="element-293" />}
    </div>;
}